import { ODataSelect } from "@iconics/core";

export class DataPoint extends ODataSelect
{
    public DataPoint_Id = "";
    public Name = "";
    public DisplayName = "";
    public IsEnabled = "";
    public SortOrder = 0;
    public DataPointType = 1;
    public DataPointDataType = 1;
    public '@odata.etag' = "";
    public DataCollectionDeviceId = "";
    public DataPointName = "";
    public ValidationRule = "";
    public ValidationRangeMinimum = "";
    public ValidationRangeMaximum = "";

    public toSelect(): string
    {
        return '';
    }
}